/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import React, { lazy, Suspense } from 'react';
import { PaymentMethods } from '../../constants/PaymentTypes';
import { ThirdPartyButtonContainer } from './ThirdPartyButtonContainer';
var ApplePay = /*#__PURE__*/lazy(function () {
  return import('../ApplePay');
});
var PayPal = /*#__PURE__*/lazy(function () {
  return import('../PayPal');
});
var Venmo = /*#__PURE__*/lazy(function () {
  return import('../Venmo');
});
var GooglePay = /*#__PURE__*/lazy(function () {
  return import('../GooglePay');
});
import { Divider, PaymentButtonsWrapper } from './styled';
import { countTotalShownButtons, isVenmoEnabled, shouldShowDivider } from '../PaymentButtons/helper';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import LoadingIndicator from '../LoadingIndicator';
import { getString } from '../../constants/Strings';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector, paymenFormSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import { getPaymentFieldLabelText } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
var PaymentButtons = /*#__PURE__*/React.memo(function (props) {
  var clientInstance = props.clientInstance;
  var config = useAppSelector(configSelector);
  var payment = useAppSelector(paymentSelector);
  var paymentForm = useAppSelector(paymenFormSelector);
  var applepayVisible = config.applepayVisible,
    supportedPaymentMethods = config.supportedPaymentMethods,
    venmoVisible = config.venmoVisible,
    googlepayVisible = config.googlepayVisible,
    country = config.country;
  var cartPriceSummary = payment.cartPriceSummary,
    deviceData = payment.deviceData;
  var paypalEnabled = (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.PAYPAL)) || false;
  var venmoEnabled = isVenmoEnabled(supportedPaymentMethods, venmoVisible, country);
  var applepayEnabled = (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.APPLEPAY)) && applepayVisible || false;
  var creditcardEnabled = (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.CREDITCARD)) || false;
  var googlepayEnabled = (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.GOOGLE_PAY)) && googlepayVisible || false;
  var buttonFlags = [paypalEnabled, applepayEnabled, venmoEnabled, googlepayEnabled];
  var showDivider = shouldShowDivider(buttonFlags, creditcardEnabled);
  var totalShownButtons = countTotalShownButtons(buttonFlags);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(LoadingIndicator, null)
  }, /*#__PURE__*/React.createElement(PaymentButtonsWrapper, {
    "data-test": DataTestAttributes.PAYMENT_BUTTONS
  }, googlepayEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(GooglePay, {
    instance: clientInstance,
    deviceData: deviceData
  })), paypalEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(PayPal, {
    instance: clientInstance,
    deviceData: deviceData
  })), venmoEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(Venmo, {
    instance: clientInstance,
    deviceData: deviceData
  })), applepayEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(ApplePay, {
    instance: clientInstance,
    deviceData: deviceData,
    cartPriceSummary: cartPriceSummary
  })))), showDivider && /*#__PURE__*/React.createElement(Divider, {
    "data-test": DataTestAttributes.DIVIDER
  }, /*#__PURE__*/React.createElement("span", null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.OR) || getString('APP.DIVIDER.OR'))));
});
export default PaymentButtons;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentButtons/PaymentButtons.js
// module id = 4545
// module chunks = 11